<template>
  <basic-container>
    <WebReport :url="url" :params="params" :roomName="roomName" :name="name" />
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import WebReport from '@/components/web-report';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import urlSettings from '@/config/url-settings.js';
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      url: '',
      form: {
        areaName: '',
        roomName: '',
        name,
      },
      areaName2: '',
      areaName: '',
      roomName: '',
      name: '',
      allPropertyList: [],
      params: {
        // reportlet: 'pmsone/oweSummary.cpt',
        //  reportlet: 'oweSummary.cpt',
      },
      dic: [],
    };
  },
  methods: {
    select(e) {
      this.form.areaName = e;
    },
    onSubmit() {
      this.params.areaName = this.form.areaName;
      this.params.roomName = this.form.roomName;
      this.roomName = this.form.roomName;
      this.name = this.form.name;
      this.params.name = this.form.name;
      this.params.account = this.userInfo.account;
    },
    initPropertyList() {
      var that = this;
      getOptionNode({}).then((data) => {
        this.allPropertyList = data.data;
        let obj = {};
        obj.title = '全部';
        obj.id = '';
        this.allPropertyList.unshift(obj);
        this.areaName2 = this.allPropertyList[0].title;
      });
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
  },

  created() {
    this.initPropertyList();
    this.params.account = this.userInfo.account;
    var reportUrl = urlSettings.BASE_REPORT_URL;
    this.url = reportUrl.split('?')[0];
    this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2FbankCharged.cpt';
  },
};
</script>

<style></style>
